module.exports = __webpack_public_path__ + "img/ACTIVITIES.f42c39a5.jpg";